module.exports = __webpack_public_path__ + "static/img/zheng_chang.92fef8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/zheng_chang.png
// module id = qPRI
// module chunks = 2